/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabHospitalAssociation from './lab-hospital-association';
import LabHospitalAssociationDetail from './lab-hospital-association-detail';
import LabHospitalAssociationUpdate from './lab-hospital-association-update';
import LabHospitalAssociationDeleteDialog from './lab-hospital-association-delete-dialog';

const LabHospitalAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabHospitalAssociation />} />
    <Route path="new" element={<LabHospitalAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<LabHospitalAssociationDetail />} />
      <Route path="edit" element={<LabHospitalAssociationUpdate />} />
      <Route path="delete" element={<LabHospitalAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabHospitalAssociationRoutes;
